export default `---
slug: turkey
country: Turkey
countryCode: TUR
continent: Asia
year: 2018
title: "Turkey"
description: "Istanbul, Cappadocia, and the crossroads of continents."
thumbnail: /images/travels/TUR/turkey_thumb.jpg
relatedLinks: []
---
![turkey](/images/travels/TUR/turkey_thumb.jpg)

*Story coming soon — stay tuned!*

I visited Turkey and it was an incredible experience. Full story and photos are being written up and will appear here soon.
`;
